import React, { useState ,useEffect } from "react";
import { useLocation, useNavigate,Link } from "react-router-dom";
import { X } from "lucide-react";
import { Accordion, Form, Button, Modal } from "react-bootstrap";
import "./CheckOut.css";
import {validatecheckout} from '../../Utils/validate';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { v4 as uuidv4 } from 'uuid';
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import { gettoastwarning } from '../../Utils/Common';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const CheckOut = () => {
  const [loading,setLoading] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
		
  const [errors,setErrors] = useState({});
		
  const [loc, setLoc]=useState([]);

const [ticket,setTicket] = useState([]);
const [member,setMember] = useState([]);
const [inputs,setInputs] = useState({});
const [inputsche,setInputsche] = useState({email:'',first_name:'',last_name:'', single_event: false,mobile_number:'',location:'',gender:'',birth_year:'',location_name:''});


  const [showFirst, setShowFirst] = useState(false);

  const [activeKey, setActiveKey] = useState("0");

  const [websetting, setWebsetting] = useState(false);

  
  
  const [isEditing, setIsEditing] = useState(true);

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  const LeaveUrl1 = () => {
    setLoading(false);
    setCurrentStep(1);
  }

  const LeaveUrl2 = () => {
    setLoading(false);
    setCurrentStep(2);
  }

  const nextStep = () => {
	  setLoading(true);
		let unq_id = localStorage.getItem('device_id');
		let formData = new FormData(); 
		formData.append('event_id', inputs.event_id);
		formData.append('unq_id', unq_id);
		API.post('check_order_is_valid_or_not_for_web',formData)
			.then(response => {
			if(response.data.status === false){
				setLoading(false);
				var u_link='/event-product/'+inputs.event_id;
				gettoastwarning('Your booking has been expired. Please try to book again.',u_link);
			}else{
				setLoading(false);
				if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
			}                  
		}).catch(error => {
			setLoading(false);
			 gettoastwarning('Something went wrong. Please try again later.','');
		});
  };
  const nextStep1 = () => {
	  const validationErrors = validatecheckout(inputsche);
	const noErrors = Object.keys(validationErrors).length === 0;
	setErrors({});
	setErrors(validationErrors);
	if(noErrors){
		setLoading(true);
    
    let formData1 = new FormData(); 
          formData1.append('event_id', inputs.event_id);
          formData1.append('email', inputsche.email);
          API.post('check_single_email_is_blocked',formData1)
            .then(response => {
            if(response.data.status === false){
              setLoading(false);
              gettoastwarning(response.data.message,'');
            }else{
          		let unq_id = localStorage.getItem('device_id');
          		let formData = new FormData(); 
          		formData.append('event_id', inputs.event_id);
          		formData.append('unq_id', unq_id);
          		API.post('check_order_is_valid_or_not_for_web',formData)
          			.then(response => {
          			if(response.data.status === false){
          				setLoading(false);
          				var u_link='/event-product/'+inputs.event_id;
          				gettoastwarning('Your booking has been expired. Please try to book again.',u_link);
          			}else{
          				setLoading(false);
          				if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
          				setActiveKey("1");
          			}                  
          		}).catch(error => {
          			setLoading(false);
          			 gettoastwarning('Something went wrong. Please try again later.','');
          		});
          }                  
        }).catch(error => {
          setLoading(false);
           gettoastwarning('Something went wrong. Please try again later.','');
        });
	}
  };
  /*const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };*/

  useEffect(() => {
  document.title = 'CheckOut | Your Friend My Friend';
  document.getElementById('bodywrap').className = 'checkout';

  /* Start get location data */
    API.get('get_location')
      .then(response => {
      if(response.data.status === false){
        
      }else{
         setLoc(response.data.data);
      }                  
    }).catch(error => {
       
    });  
   /* End get location data */

    /* Start get purchase settings data */
    API.get('get_purchase_settings_web')
      .then(response => {
      if(response.data.status === false){
          setWebsetting(false);
      }else{
          setWebsetting(true);
      }                  
    }).catch(error => {
       
    });  
   /* End get purchase settings data */


	let device_id = localStorage.getItem('device_id');
	if (!device_id) {
	  device_id = uuidv4();
	  localStorage.setItem('device_id', device_id);
	}

  const state = location.state;

  if (!state || !state.member || !state.ticket || !state.inputs) {
    navigate('/');
    return;
  }
  setInputs(state.inputs);
  setTicket(state.ticket);
  setMember(state.member);
 
  const ticket_cal = () => {
    let sub_total = 0;
    let total_fees = 0;
    let total_vat = 0;

    location.state.ticket.forEach((val) => {
      if (val.qty > 0) {
        sub_total += parseFloat(val.price) || 0;
        total_fees += parseFloat(val.total_fees) || 0;
        total_vat += parseFloat(val.total_vat) || 0;
      }
    });

    const grand_total = parseFloat((sub_total + total_fees + total_vat).toFixed(2));

    sub_total = sub_total.toFixed(2);
    total_fees = total_fees.toFixed(2);
    total_vat = total_vat.toFixed(2);

    setInputs(inputs => ({
      ...inputs,
      sub_total,
      total_fees,
      total_vat,
      grand_total
    }));
  }
  
  ticket_cal();
}, [location, navigate]);

/* Start Value set */
const handleInputChange = (event) => {
      event.persist();
      const { name, value } = event.target;
    

    // Mobile: only + and numbers
    if (name === "mobile_number") {
      // allow only one + and only at start
      if (!/^\+?\d*$/.test(value)) {
        return;
      }
    }
      setInputsche(inputsche => ({...inputsche, [event.target.name]: event.target.value})); 
}
const step1 = () => {
	const validationErrors = validatecheckout(inputsche);
	const noErrors = Object.keys(validationErrors).length === 0;
	setErrors({});
	setErrors(validationErrors);
	if(noErrors){
		setLoading(true);

    let formData1 = new FormData(); 
          formData1.append('event_id', inputs.event_id);
          formData1.append('email', inputsche.email);
         
          API.post('check_single_email_is_blocked',formData1)
            .then(response => {
            if(response.data.status === false){
              setLoading(false);
              gettoastwarning(response.data.message,'');
            }else{
            		let unq_id = localStorage.getItem('device_id');
            		let formData = new FormData(); 
            		formData.append('event_id', inputs.event_id);
            		formData.append('unq_id', unq_id);
            		API.post('check_order_is_valid_or_not_for_web',formData)
            			.then(response => {
            			if(response.data.status === false){
            				setLoading(false);
            				var u_link='/event-product/'+inputs.event_id;
            				gettoastwarning('Your booking has been expired. Please try to book again.',u_link);
            			}else{	
            				setLoading(false);
            				setActiveKey('1');
            				setIsEditing(false);
            			}                  
            		}).catch(error => {
            			setLoading(false);
            			 gettoastwarning('Something went wrong. Please try again later.','');
            		});
          }                  
        }).catch(error => {
          setLoading(false);
           gettoastwarning('Something went wrong. Please try again later.','');
        });
	}
}
const LeaveUrl = () => {
	setLoading(true);
	let unq_id = localStorage.getItem('device_id');
	let formData = new FormData(); 
	formData.append('event_id', inputs.event_id);
	formData.append('unq_id', unq_id);
	API.post('leave_check_out_for_web',formData)
		.then(response => {
		if(response.data.status === false){
			setLoading(false);
			var u_link='/event-product/'+inputs.event_id;
			gettoastwarning('Your booking has been expired. Please try to book again.',u_link);
		}else{
			setLoading(false);
			window.location.href = '/event-product/'+inputs.event_id;
			//navigate('/event-product-page/'+inputs.event_id);
		}                  
	}).catch(error => {
		setLoading(false);
		 gettoastwarning('Something went wrong. Please try again later.','');
	});
}

const handleInputChangeLocation = (e) => {
  const selectedOption = e.target.options[e.target.selectedIndex];
  const locationName = selectedOption.getAttribute("data-name");

  setInputsche(prev => ({
    ...prev,
    location: e.target.value,   // id
    location_name: locationName,   // name
  }));
};

const handleInputChangeCustom = (field, value) => {
    setInputsche({ ...inputsche, [field]: value })
  }
const web_purchase_test = async () => {
  const validationErrors = validatecheckout(inputsche);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
  // setLoading(true);
 
    try {
        const unq_id = localStorage.getItem('device_id');
        
        // Check if the order is still valid
        let formData1 = new FormData();
        formData1.append('event_id', inputs.event_id);
        formData1.append('unq_id', unq_id);
 
        const checkResponse = await API.post('check_order_is_valid_or_not_for_web', formData1);
 
        if (checkResponse.data.status === false) {
            setLoading(false);
            const u_link = `/event-product/${inputs.event_id}`;
            gettoastwarning('Your booking has been expired. Please try to book again.', u_link);
            return;
        }
 
        // Prepare tickets data
        const allNewMembers = member.map((val) => ({
            ticket_id: val.ticket_id,
            price: val.booking_price,
            qty: 1,
            fees_percentage: val.fees_percentage,
            vat_percentage: val.vat_percentage,
            total_fees: val.total_fees,
            total_vat: val.total_vat,
            user_id: 0,
            first_name: val.first_name,
            last_name: val.last_name,
            email: val.email,
            mobile_number: val.phone_number,
            country_code: val.country_code,
            age: val.age,
            is_wingman:val.is_wingman,
            question: val.question.map(innerItem => ({
                id: innerItem.id,
                question_type: innerItem.type,
                option_id: innerItem.option_val,
                answer: innerItem.answer_text
            }))
        }));

        const allNewTicket = [];
      
      ticket.forEach((val) => {
        if (val.qty > 0) {
          const newTicket = {
            ticket_id: val.id,
            price: val.booking_price,
            qty: val.qty,
            is_wingman: val.is_wingman,
          };
          allNewTicket.push(newTicket);
        }
      });
 
            // Create payment intent
            let formData = new FormData();
            formData.append('amount', inputs.grand_total);
            formData.append('event_id', inputs.event_id);
            formData.append('stripe_token', 'ffff');
            formData.append('email', inputsche.email);
            formData.append('first_name', inputsche.first_name);
            formData.append('last_name', inputsche.last_name);
            formData.append('tickets', JSON.stringify(allNewMembers));
            formData.append('ticket_qty_data', JSON.stringify(allNewTicket));
            formData.append('subtotal', inputs.sub_total);
            formData.append('totalfees', inputs.total_fees);
            formData.append('totalvat', inputs.total_vat);
            formData.append('grand_total', inputs.grand_total);
            formData.append('promo_code_used', 0);
            formData.append('promo_code_id', 0);
            formData.append('promo_code_percentage', 0);
            formData.append('promo_code_discount', 0);
            formData.append('unq_id', unq_id); // If you meant to send unq_id, use formData.append('unq_id', unq_id);
            formData.append('type', 'Web');
            formData.append('tickets_type', inputsche.tickets_type);
        formData.append('is_newsletter', inputsche.single_event ? 1 : 0);
        formData.append('tax_type', inputs.tax_type);
        formData.append('symbol', inputs.symbol);
        formData.append('currency', inputs.currency);
        if(inputsche.single_event)
        {
          formData.append('mobile_number', inputsche.mobile_number);
          formData.append('location', inputsche.location);
          formData.append('location_name', inputsche.location_name);
          formData.append('gender', inputsche.gender);
          formData.append('birth_year', inputsche.birth_year);
        }

        
          API.post('purchase_tickets_web', formData)
            .then(response1 => {
              
            if(response1.data.status === false){
              setLoading(false);
              gettoastwarning(response1.data.message,'');
            }else{
               var order_number=response1.data.data.order_number;
               navigate('/order-completed',{ state: { order_number:order_number } });
            }                  
          }).catch(error => {
             setLoading(false);
             var msg='Payment: '+error.message;
             gettoastwarning(msg,'');
          }); 
 
    } catch (error) {
    setLoading(false);
        console.error(error);
    var msg='Payment Intent: '+error.message;
        gettoastwarning(msg, '');
    } finally {
        //setLoading(false);
    }
  }
}


const register_now = async () => {

const validationErrors = validatecheckout(inputsche);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){

  setLoading(true);
 
    try {
        const unq_id = localStorage.getItem('device_id');
        
        // Check if the order is still valid
        let formData1 = new FormData();
        formData1.append('event_id', inputs.event_id);
        formData1.append('unq_id', unq_id);
 
        const checkResponse = await API.post('check_order_is_valid_or_not_for_web', formData1);
 
        if (checkResponse.data.status === false) {
            setLoading(false);
            const u_link = `/event-product/${inputs.event_id}`;
            gettoastwarning('Your booking has been expired. Please try to book again.', u_link);
            return;
        }
 
        // Prepare tickets data
        const allNewMembers = member.map((val) => ({
            ticket_id: val.ticket_id,
            price: val.booking_price,
            qty: 1,
            fees_percentage: val.fees_percentage,
            vat_percentage: val.vat_percentage,
            total_fees: val.total_fees,
            total_vat: val.total_vat,
            user_id: 0,
            first_name: val.first_name,
            last_name: val.last_name,
            email: val.email,
            mobile_number: val.phone_number,
            country_code: val.country_code,
            age: val.age,
            is_wingman:val.is_wingman,
            question: val.question.map(innerItem => ({
                id: innerItem.id,
                question_type: innerItem.type,
                option_id: innerItem.option_val,
                answer: innerItem.answer_text
            }))
        }));
 

        const allNewTicket = [];
      
          ticket.forEach((val) => {
            if (val.qty > 0) {
              const newTicket = {
                ticket_id: val.id,
                price: val.booking_price,
                qty: val.qty,
                is_wingman: val.is_wingman,
              };
              allNewTicket.push(newTicket);
            }
          });

            // Create payment intent
            let formData = new FormData();
            formData.append('amount', inputs.grand_total);
            formData.append('event_id', inputs.event_id);
            formData.append('stripe_token', 'ffff');
            formData.append('email', inputsche.email);
            formData.append('first_name', inputsche.first_name);
            formData.append('last_name', inputsche.last_name);
            formData.append('tickets', JSON.stringify(allNewMembers));
            formData.append('ticket_qty_data', JSON.stringify(allNewTicket));
            formData.append('tickets_type', inputsche.tickets_type);
            formData.append('subtotal', inputs.sub_total);
            formData.append('totalfees', inputs.total_fees);
            formData.append('totalvat', inputs.total_vat);
            formData.append('grand_total', inputs.grand_total);
            formData.append('promo_code_used', 0);
            formData.append('promo_code_id', 0);
            formData.append('promo_code_percentage', 0);
            formData.append('promo_code_discount', 0);
            formData.append('unq_id', unq_id); // If you meant to send unq_id, use formData.append('unq_id', unq_id);
            formData.append('type', 'Web');
        formData.append('is_newsletter', inputsche.single_event ? 1 : 0);
        formData.append('tax_type', inputs.tax_type);
        formData.append('symbol', inputs.symbol);
        formData.append('currency', inputs.currency);
        if(inputsche.single_event)
        {
          formData.append('mobile_number', inputsche.mobile_number);
          formData.append('location', inputsche.location);
          formData.append('location_name', inputsche.location_name);
          formData.append('gender', inputsche.gender);
          formData.append('birth_year', inputsche.birth_year);
        }
          API.post('purchase_free_tickets_for_web', formData)
            .then(response1 => {
              
            if(response1.data.status === false){
              setLoading(false);
              gettoastwarning(response1.data.message,'');
            }else{
               var order_number=response1.data.data.order_number;
               navigate('/order-completed',{ state: { order_number:order_number } });
            }                  
          }).catch(error => {
             setLoading(false);
             var msg='Payment: '+error.message;
             gettoastwarning(msg,'');
          }); 
 
    } catch (error) {
    setLoading(false);
        console.error(error);
    var msg='Payment Intent: '+error.message;
        gettoastwarning(msg, '');
    } finally {
        //setLoading(false);
    }
  }
}

  return (
    <>
      <div className="container-fluid out d-none d-md-block">
        <div className="text-left mb-4">
          <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back-top-logo.png'} alt="back-logo" />
        </div>

        <div className="hyy mb-4">
          <button className="custom-close pora p-0 pt-2" onClick={() => { setShowFirst(true); }}>
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
              alt="Close"
              style={{ width: "18px" }}
            />
          </button>
        </div>

        <div className="row">
          <div className="col-md-7">
            <Accordion activeKey={activeKey}>
              <Accordion.Item eventKey="0">
                <Accordion.Header onClick={() => setActiveKey("0")}>
                  <div className="w-100">
                    <div className="w-100 mb-3">1. Contact information</div>
                    {!isEditing && (
                      <div className="d-flex justify-content-between align-items-center after">
                        <span>{inputsche.email || "Enter your email"}</span>
                        <Button
						 type="button"
                          className=""
                          variant="link"
                          onClick={() => {
                            setIsEditing(true);
                            setActiveKey("0");
                          }}
                        >
                          Edit
                        </Button>
                      </div>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  {isEditing ? (
                    <Form>
                      <div className="row g-3 mb-3">
                        <div className="col-md-12">
                          <Form.Group controlId="email">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.email}
                              placeholder="Enter email"
							  name="email"
							  onChange={handleInputChange}
                            />
							{errors.email && (<p className="text-danger">{errors.email}</p>)}
                          </Form.Group>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <Form.Group controlId="firstName">
                            <Form.Label>First name *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.first_name}
                              placeholder="First Name"
							  name="first_name"
							  onChange={handleInputChange}
                            />
							{errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group controlId="lastName">
                            <Form.Label>Last Name *</Form.Label>
                            <Form.Control
                              type="text"
                              value={inputsche.last_name}
                              placeholder="Last Name"
							  name="last_name"
							  onChange={handleInputChange}
                            />
							{errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                          </Form.Group>
                        </div>
                      </div>

                      <div className="row g-3 ">
                        <div className="col-md-12">
                          <div className="form-check mb-3 d-flex align-items-center sign-ghar mt-3 gap-0">
                            <input
                              type="checkbox"
                              className={`form-check-input`}
                              id="single_event"
                              value={inputsche.single_event ? '1' : ''}
                              checked={inputsche.single_event}
                              onChange={(event) => handleInputChangeCustom('single_event', event.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="single_event">
                              Keep me in the loop with email updates about upcoming YFMF singles events and news. See our <Link to="/privacy-policy" target="_blank" className="text-decoration-none pri-link">Privacy Policy</Link>.
                            </label>
                          </div>
                        </div>
                      </div>
                      {inputsche.single_event && (
                        <>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>Mobile Number </Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.mobile_number}
                                placeholder="Mobile Number"
                                name="mobile_number"
                                onChange={handleInputChange}
                              />
                              {errors.mobile_number && (<p className="text-danger">{errors.mobile_number}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Location *</Form.Label>
                              <select className="form-control custom-input" name="location" value={inputsche.location} onChange={handleInputChangeLocation}>
                                <option value="">Location</option>
                                {loc.map((val, i) => (
                                <option value={val.id} data-name={val.name}>{val.name}</option>
                                ))}
                              </select>
                              {errors.location && (<p className="text-danger">{errors.location}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>Gender *</Form.Label>
                              <select className="form-control custom-input" name="gender" value={inputsche.gender} onChange={handleInputChange}>
                                <option value="">Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Non-binary">Non-binary</option>
                              </select>
                              {errors.gender && (<p className="text-danger">{errors.gender}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Birth Year *</Form.Label>
                              <select name="birth_year" id="birth_year" className="form-control custom-input" value={inputsche.birth_year} onChange={handleInputChange}>
                                <option value="">Birth Year </option>
                                {Array.from(
                                  { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                                  (_, i) => 1940 + i
                                ).map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                            </select>
                              {errors.birth_year && (<p className="text-danger">{errors.birth_year}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        </>
                      )}

                     {
                      websetting === false ? (
                        inputs.is_free_event === 0 ? (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={step1}
                          >
                            NEXT STEP
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={register_now}
                          >
                            Register Now
                          </Button>
                        )
                      ) : (
                        inputs.is_free_event === 0 ? (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={web_purchase_test}
                          >
                            Test Payment
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={register_now}
                          >
                            Register Now
                          </Button>
                        )
                      )
                    }
                    </Form>
                  ) : null}
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>2. Payment</Accordion.Header>
                <Accordion.Body>
                    <Elements stripe={stripePromise}>
      					  <CheckoutForm inputs={inputs} member={member} inputsche={inputsche} ticket={ticket} />
      					</Elements>

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h5>Order Summary</h5>
				{ticket && ticket.map((val, index) => {
				  if (val.qty > 0) {
					return (
					  <p key={index}>
						{val.name}
						<span className="float-end">{inputs.symbol}{val.price}</span>
					  </p>
					);
				  } else {
					return null;
				  }
				})}
                
                <hr />
                <p>
                  Subtotal <span className="float-end">{inputs.symbol}{inputs.sub_total}</span>
                </p>
                <p>
                  Fees <span className="float-end">{inputs.symbol}{inputs.total_fees}</span>
                </p>
                <p>
                  {inputs.vat_percentage}% {inputs.tax_type} <span className="float-end">{inputs.symbol}{inputs.total_vat}</span>
                </p>
                <hr />
                <h6>
                  Total <span className="float-end">{inputs.symbol}{Number(inputs.grand_total).toFixed(2)}</span>
                </h6>
                <p className="text-end">Price includes tax</p>
                <hr />
                <h6>Refund Policy</h6>
                <p className="text-muted">
                  Refunds up to 2 days before the event.
                </p>
                <h4>
                  Total <span className="float-end">{inputs.symbol}{Number(inputs.grand_total).toFixed(2)}</span>
                </h4>
              </div>
            </div>
            {/* <Button className="mt-4 ne" onClick={() => { setShowFirst(true); }}>
              Leave Checkout
            </Button> */}
          </div>
        </div>
      </div>

      <Modal
        show={showFirst}
        onHide={() => setShowFirst(false)}
        centered
        size="lg"
        className="newyesrt"
      >
        <div className="leav">
          <div className="close-btn" onClick={() => setShowFirst(false)}>
            <X size={30} />
          </div>
          <Modal.Body className="text-center p-4">
            <h4>Leave checkout?</h4>
            <p>
              Are you sure you want to leave checkout? <br></br>
              The item you’ve selected may not be available later
            </p>
            <div className="d-flex justify-content-center gap-2 noyle">
              <Button type="button" className="w-100 st" onClick={() => setShowFirst(false)}>STAY</Button>
              <Button type="button" className="w-100 le" onClick={() => { LeaveUrl(); }}>
                LEAVE
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      {/* Mobile Step View */}
      <div className="d-block d-md-none">
        {/* Step Content */}
        {currentStep === 1 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
                <button className="custom-close p-0 pt-2" onClick={() => { setShowFirst(true); }}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
                    alt="Close"
                    style={{ width: "18px" }}
                  />
                </button>
            </div>
            <div className="row flex-grow-1">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body align-items-start">
                    {/* <div className="hyy" onClick={() => { setShowFirst(true); }}>
                      <button type="button" 
                        className="holo ord-btn-back"
                      >
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                      </button>
                    </div> */}

                    <h5>Order Summary</h5>
            					{ticket && ticket.map((val, index) => {
            				  if (val.qty > 0) {
            					return (
                                <p>
                                  {val.name}
                                  <span className="float-end">{inputs.symbol}{val.price}</span>
                                </p>
            					);
            				  } else {
            					return null;
            				  }
            				})}
                    
                    <hr />
                    <p>
                      Subtotal <span className="float-end">{inputs.symbol}{inputs.sub_total}</span>
                    </p>
                    <p>
                      Fees <span className="float-end">{inputs.symbol}{inputs.total_fees}</span>
                    </p>
                    <p>
                      {inputs.vat_percentage}% {inputs.tax_type} <span className="float-end">{inputs.symbol}{inputs.total_vat}</span>
                    </p>
                    <hr />
                    <h6>
                      Total <span className="float-end">{inputs.symbol}{Number(inputs.grand_total).toFixed(2)}</span>
                    </h6>
                    <p className="text-end">Price includes tax</p>
                    <hr />
                    <h6>Refund Policy</h6>
                    <p className="text-muted">
                      Refunds up to 2 days before the event.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row pb-4">
              <div className="col-md-12">
                <h4>
                  Total <span className="float-end">{inputs.symbol}{inputs.grand_total}</span>
                </h4>
                <Button type="button"
                  className="mt-4 w-100 ne"
                  onClick={() => {
                    nextStep();
                  }}
                >
                  CHECKOUT
                </Button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
                <button className="koma-se" onClick={() => { LeaveUrl1(); }} >
                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                </button>
              <button className="custom-close p-0 pt-2" onClick={() => { setShowFirst(true); }}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
                    alt="Close"
                    style={{ width: "18px" }}
                  />
                </button>
            </div>

            <div className="row flex-grow-1">
              <div className="col-md-12">
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header onClick={() => setActiveKey("0")}>
                      <div className="w-100">
                        {/* <div className="hyy">
                          <Link
                            className="holo"
                              href="#" onClick={(e) => { e.preventDefault(); setShowFirst(true); }}>
                            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                          </Link>
                        </div> */}
                        <div className="w-100">1. Contact information</div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Form>
                        <div className="row g-3 mb-3">
                          <div className="col-md-12">
                            <Form.Group controlId="email">
                              <Form.Label>Email *</Form.Label>
                              <Form.Control
                                type="text"
								value={inputsche.email}
                                name="email"
								onChange={handleInputChange}
                                placeholder="Enter email"
                              />
							  {errors.email && (<p className="text-danger">{errors.email}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>First name *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.first_name}
                                name="first_name"
								                onChange={handleInputChange}
                                placeholder="First Name"
                              />
							  {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Last Name *</Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.last_name}
                                name="last_name"
								onChange={handleInputChange}
                                placeholder="Last Name"
								
                              />
							  {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                            </Form.Group>
                          </div>
                        </div>

                        <div className="row g-3 ">
                        <div className="col-md-12">
                          <div className="form-check mb-3 d-flex align-items-start sign-ghar mt-3 gap-0">
                            <input
                              type="checkbox"
                              className={`form-check-input`}
                              id="single_event"
                              value={inputsche.single_event ? '1' : ''}
                              checked={inputsche.single_event}
                              onChange={(event) => handleInputChangeCustom('single_event', event.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="single_event">
                              Keep me in the loop with email updates about upcoming YFMF singles events and news. See our <Link to="/privacy-policy" target="_blank" className="text-decoration-none pri-link">Privacy Policy</Link>.
                            </label>
                          </div>
                        </div>
                      </div>
                      {inputsche.single_event && (
                        <>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>Mobile Number </Form.Label>
                              <Form.Control
                                type="text"
                                value={inputsche.mobile_number}
                                placeholder="Mobile Number"
                                name="mobile_number"
                                onChange={handleInputChange}
                              />
                              {errors.mobile_number && (<p className="text-danger">{errors.mobile_number}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Location *</Form.Label>
                              <select className="form-control custom-input" name="location" value={inputsche.location} onChange={handleInputChangeLocation}>
                                <option value="">Location</option>
                                {loc.map((val, i) => (
                                <option value={val.id} data-name={val.name}>{val.name}</option>
                                ))}
                              </select>
                              {errors.location && (<p className="text-danger">{errors.location}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        <div className="row g-3 mt-1">
                          <div className="col-md-6">
                            <Form.Group controlId="firstName">
                              <Form.Label>Gender *</Form.Label>
                              <select className="form-control custom-input" name="gender" value={inputsche.gender} onChange={handleInputChange}>
                                <option value="">Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Non-binary">Non-binary</option>
                              </select>
                              {errors.gender && (<p className="text-danger">{errors.gender}</p>)}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group controlId="lastName">
                              <Form.Label>Birth Year *</Form.Label>
                              <select name="birth_year" id="birth_year" className="form-control custom-input" value={inputsche.birth_year} onChange={handleInputChange}>
                                <option value="">Birth Year </option>
                                {Array.from(
                                  { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                                  (_, i) => 1940 + i
                                ).map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                            </select>
                              {errors.birth_year && (<p className="text-danger">{errors.birth_year}</p>)}
                            </Form.Group>
                          </div>
                        </div>
                        </>
                      )}



                      </Form>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

            <div className="row pb-4">
              <div className="col-md-12">


                {
                      websetting === false ? (
                        inputs.is_free_event === 0 ? (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={nextStep1}
                          >
                            NEXT STEP
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={register_now}
                          >
                            Register Now
                          </Button>
                        )
                      ) : (
                        inputs.is_free_event === 0 ? (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={web_purchase_test}
                          >
                            Test Payment
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            className="mt-4 w-100 ne"
                            onClick={register_now}
                          >
                            Register Now
                          </Button>
                        )
                      )
                    }


                
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="container-fluid out d-flex flex-column vh-100">
            <div className="row text-center mb-5">
                <button className="koma-se" onClick={() => { LeaveUrl2(); }} >
                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                </button>
                <button className="custom-close p-0 pt-2" onClick={() => { setShowFirst(true); }}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
                    alt="Close"
                    style={{ width: "18px" }}
                  />
                </button>
            </div>

            <div className="row flex-grow-1">
              <div className="col-md-12">
                <Accordion activeKey={activeKey}>
                  <Accordion.Item eventKey="1">
                    {/* <div className="hyy">
                      <Link
                        className="holo"
                        href="#" onClick={(e) => { e.preventDefault(); setShowFirst(true); }}
                      >
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
                      </Link>
                    </div> */}
                    <Accordion.Header>2. Payment</Accordion.Header>
                    <Accordion.Body>
                      <Elements stripe={stripePromise}>
					  <CheckoutForm inputs={inputs} member={member} inputsche={inputsche} ticket={ticket} />
					</Elements>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        )}
      </div>
	  {loading && (
		   <div className="loadingClass">
				<img src={loader} alt="loader"/>
			</div>
		)} 
    </>
  );
};

export default CheckOut;
